import { useFormContext } from "./formElements";
import { Button, Form, Table } from "react-bootstrap";

export function CurrentMeasureTable(props) {
  const element = props.value;
  const { onChange } = useFormContext();
  const header = element.table_head;
  const values = element.value;

  const handleAddRow = () => {
    // nowy wiersz na wzór pierwszego (typy/opcje), z pustymi wartościami
    const template = values[0];
    const newRow = template
      ? template.map((column) => ({ ...column, value: "" }))
      : header.map((h) => ({
          type: h.type || "text",
          label: h.label,
          options: h.options,
          value: "",
        }));
    element.value = [...values, newRow];
    onChange({ ...element });
  };

  const getRow = (index) => {
    const data = values[index];

    const handleDeleteRow = () => {
      element.value.splice(index, 1);
      onChange({ ...element });
    };

    return (
      <tr key={index}>
        {data.map((column, x) => (
          <td className={"p-0 border-2"} key={x}>
            {column.type === "select" ? (
              <Form.Select
                className={"border-0 bg-transparent "}
                aria-label={column.label}
                value={column.value}
                onChange={(event) => {
                  const newVal = event.target.value;
                  data[x] = { ...column, value: newVal };
                  element.value[index] = data;
                  onChange(element);
                }}
              >
                <option value=""></option>
                {column.options?.map((opt, i) => (
                  <option key={i} value={opt.value}>
                    {opt.value} - {opt.label}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.Control
                className={"border-0 bg-transparent "}
                type={column.type}
                value={column.value}
                placeholder={column.label}
                onChange={(event) => {
                  const newVal = event.target.value;
                  data[x] = { ...column, value: newVal };
                  element.value[index] = data;
                  onChange(element);
                }}
              />
            )}
          </td>
        ))}
        <td className="align-middle text-center">
          <div
            className={"btn-close"}
            title="Usuń wiersz"
            onClick={handleDeleteRow}
          ></div>
        </td>
      </tr>
    );
  };

  return (
    <div className="mt-3 m-2">
      <Form.Control
        type="text"
        value={element.label || ""}
        placeholder="Tytuł tabeli"
        className="border-0 bg-transparent fs-5 mb-1"
        onChange={(event) => {
          element.label = event.target.value;
          onChange(element);
        }}
      />
      <div className="aeration_table">
        <Table striped bordered hover className="aeration-table" size="sm">
          <thead>
            <tr>
              {header.map((h, index) => (
                <th key={index} className="text-center">
                  {h.label}
                </th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>{values.map((row, index) => getRow(index))}</tbody>
        </Table>
      </div>
      <Button variant="outline-primary" size="sm" onClick={handleAddRow}>
        Dodaj silnik
      </Button>
    </div>
  );
}
